module.exports = __webpack_public_path__ + "static/media/stockhausen_cartagena_3.a02df5c9.jpg";